/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Per-survey readiness shown on the Review Survey Status step (step 2). Taken purely from the new survey's DataHub displayLoadStatus (mirrors the survey-list Status column): LOADED → available, IN_PROGRESS → processing, AWAITING_VENDOR → awaitingVendorMaterials, FILE_RECEIVED/UNDER_REVIEW → withBettercomp, LOAD_FAILED → failed, EMPTY → awaitingData. `awaitingData` is now only the state it names: nothing has ever been uploaded, so the customer is the one who has to act. `awaitingVendorMaterials` is the customer choosing "wait until Bettercomp has it" in the Add Survey wizard — Bettercomp still has to source the vendor's data. It is not vendor entitlement pre-verification; that state has no contract value yet.
 */
export enum SurveySeasonSurveyReviewStatus {
    AVAILABLE = 'available',
    AWAITING_DATA = 'awaitingData',
    PROCESSING = 'processing',
    FAILED = 'failed',
    AWAITING_VENDOR_MATERIALS = 'awaitingVendorMaterials',
    WITH_BETTERCOMP = 'withBettercomp',
    UNKNOWN = 'unknown',
}
